/* eslint-disable @typescript-eslint/no-explicit-any */
import { BavelUser } from "@account/models/bavel-user.model";
import { IFeatureToggleResponse } from "@shared/interfaces/feature-toggle-response.interface";
import { IUserProfileInfo } from "@shared/interfaces/user-profile-info.interface";
import { LoginResponse } from "@account/models/login-response.model";
import { Observable } from "rxjs";

export abstract class IUsersService {

    public abstract currentUser: BavelUser;
    public abstract userProfile: IUserProfileInfo;
    public abstract onLoggedIn$: Observable<any>;
    public abstract get loggedUsername(): string;
    public abstract get isImpersonated(): boolean;
    public abstract get sessionId(): string;
    public abstract storeUserProfile(loginResponse: LoginResponse): void;
    public abstract signoutRedirect(): void;
    public abstract getProfile(): Observable<IUserProfileInfo>;
    public abstract getUserId(): number;
    public abstract userHasRole(role: string): boolean;
    public abstract get isUserProfileAvailable(): Observable<boolean>;
    public abstract signInRedirect(returnUrl: string): void;
    public abstract completeAuthentication(): Promise<void>;
    public abstract canChangeUser(): boolean;
    public abstract isPartnerPortalDigitalArchiveEnabled(): Observable<IFeatureToggleResponse>;
    public abstract shouldLogoutOnUserInactivity(): boolean;
    public abstract getTokenIfExists(): Observable<string | null>;
}
